import React from 'react'
import {Link} from 'react-static'
import {Card,CardBody,CardText,CardTitle,CardFooter,Button} from 'reactstrap'
import {
  sendEmailVerification
} from '../actions/account'

export default ({email}) =>
  <Card>
    <CardBody>
      <CardTitle>Ihr Konto ist noch nciht aktiviert!</CardTitle>
      <CardText>
        Wir haben eine Email mit dem Aktivierungslink
        an <strong>{email}</strong> gesendet, bitte folgen Sie diesem Link.
        <br/>
        <br/>
        Sie haben keine Email bekommen?
      </CardText>
      <Button color='primary' onClick={sendEmailVerification}>
        Erneut senden
      </Button>

    </CardBody>
    <CardFooter>
      <Link to='/signout'>Andere Email verwenden</Link>
    </CardFooter>
  </Card>



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/ActivateAccount.js